export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s is niet gekozen';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s mag niet leeg zijn';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s is een verplicht veld';
                break;

            case 'address-autocomplete':
                translation = 'Selecteer een adres uit de lijst';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s is niet correct ingevuld';
                break;

            case 'opt-in':
                translation = 'Vink de checkbox aan om verder te gaan';
                break;

            default:
                translation = 'Dit veld is incorrect ingevuld';
                break;
        }

        return translation;
    }

    smsVerify(textType) {
        let translation = '';

        switch (textType) {
            case 'template':
                translation = 'Uw verificatiecode is %token.';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = 'Geen resultaten gevonden';
                break;

            case 'address-not-checked':
                translation = 'Sleep de kaart en plaats de speld op het dak van uw huis';
                break;

            default:
                translation = 'Er is een fout opgetreden';
                break;
        }

        return translation;
    }
}
